import { useLazyFetchClientServiceLevelAgreementStatusesListQuery } from "../../../services/clientserviceterms";

const useClientServiceLevelAgreementStatuses = () => {

    const [fetch, { data, error: updateError, isError: isErrorUpdating, isLoading: isUpdating }] = useLazyFetchClientServiceLevelAgreementStatusesListQuery();

    const fetchStatuses = (cslaId) => {
        return new Promise((resolve, reject) => {
            return fetch({ cslaId }).unwrap().then(
                r => resolve(r),
                e => reject(e)
            );
        });
    }

    return {
       fetchStatuses,
       data: data || [],
    };
};

export default useClientServiceLevelAgreementStatuses;